import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { ICancelBackgroundJobAction } from '../../spacesPlatform/models/actionNames';
import { navigateToBackgroundJobTaskDetailsAction } from '../actions/NavigateToBackgroundJobTaskDetailsAction';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';

export const ViewBackgroundJobDetailsAction: IEntityAction<IBackgroundJobInfo, ICancelBackgroundJobAction> = {
  name: EntityActionNames.ViewBackgroundJobDetails,
  translateName: Messages.viewDetails,
  isVisible: () => FeatureFlags.backgroundJobsContentAndTaskDetailsEnabled,
  isClickable: (availableActions: ICancelBackgroundJobAction, targetItems: IBackgroundJobInfo[]) => !!targetItems[0]?.taskLuid,
  createReduxAction: (targetItems: IBackgroundJobInfo[]) => navigateToBackgroundJobTaskDetailsAction(targetItems[0])
};
